import { defineFormSchema } from '../../../shared/data/formSchema';
export const formSchema = defineFormSchema({
  "id": "clients.client.create",
  "fields": [
    { "name": "notes", "label": "Descrizione", "type": "textarea" },
    {
      "name": "name",
      "label": "Nome Completo",
      "type": "text"
    },
    {
      "name": "businessName",
      "label": "Ragione Sociale",
      "type": "text"
    },
    {
      "name": "tipoCliente",
      "label": "Tipo Cliente",
      "type": "select"
    },
    {
      "name": "company",
      "label": "Azienda",
      "type": "text"
    },
    {
      "name": "codiceFiscale",
      "label": "Codice Fiscale",
      "type": "text"
    },
    {
      "name": "vatNumber",
      "label": "Partita IVA",
      "type": "text"
    },
    {
      "name": "numeroREA",
      "label": "Numero REA",
      "type": "text"
    },
    {
      "name": "formaGiuridica",
      "label": "Forma Giuridica",
      "type": "text"
    },
    {
      "name": "indirizzoSedeLegale",
      "label": "Indirizzo Sede Legale",
      "type": "text"
    },
    {
      "name": "sector",
      "label": "Settore",
      "type": "text"
    },
    {
      "name": "contattiPersonali.email",
      "label": "Email Personale",
      "type": "email"
    },
    {
      "name": "contattiPersonali.phone",
      "label": "Telefono Personale",
      "type": "tel"
    },
    {
      "name": "contattiAziendali.email",
      "label": "Email Aziendale",
      "type": "email"
    },
    {
      "name": "contattiAziendali.phone",
      "label": "Telefono Aziendale",
      "type": "tel"
    },
    {
      "name": "referredBy",
      "label": "Riferito da",
      "type": "text"
    }
  ]
});
